import { createSlice } from "@reduxjs/toolkit";
import { PURGE } from "redux-persist";
import { getUsersData } from "../actions/getUsersDataAction";

const initialState = {
    Object:null,
    loading : 'idle',
    hasError: false,
    errorMessage: ''
}
const userDataSlice = createSlice({
    name: 'userData',
    initialState,
    reducers: {
         resetState: () => {
            return initialState;
        }

    },
    extraReducers: (builder) => {
        builder.addCase(PURGE, () => {
            return initialState;
        })
            .addCase(getUsersData.pending, (state) => {
                state.loading = 'pending';
                state.hasError = false
            })
            .addCase(getUsersData.fulfilled, (state, action) => {
                state.loading = 'succeeded';
                state.hasError = false;
                state.Object = action.payload ;
                state.errorMessage = ""


            })
            .addCase(getUsersData.rejected, (state, action) => {
                state.loading = 'failed';
                state.hasError = true;
                state.errorMessage = action.payload
            })
    }
});
export const { deleteFileById , resetState } = userDataSlice.actions;

export default userDataSlice.reducer;